import FJConfig from '../FJConfig';

export const MOBILE_IMAGE_ENHANCER_PREVIEW_SRC =
    FJConfig.imgPath + 'mobileImageEnhancer/' + 'image-enhancer-preview.mp4?v=' + FJConfig.version;
